var _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "198pt",
    height: "61pt",
    viewBox: "0 0 198 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.953125 -1.25 C 1.515625 -0.53125 1.09375 -0.375 0.609375 -0.34375 C 0.484375 -0.328125 0.375 -0.328125 0.375 -0.125 C 0.375 -0.046875 0.4375 0 0.53125 0 C 0.8125 0 1.15625 -0.03125 1.46875 -0.03125 C 1.828125 -0.03125 2.203125 0 2.546875 0 C 2.625 0 2.765625 0 2.765625 -0.203125 C 2.765625 -0.328125 2.65625 -0.34375 2.578125 -0.34375 C 2.328125 -0.359375 2.078125 -0.453125 2.078125 -0.71875 C 2.078125 -0.84375 2.140625 -0.96875 2.21875 -1.125 L 3.046875 -2.515625 L 5.796875 -2.515625 C 5.8125 -2.296875 5.96875 -0.8125 5.96875 -0.703125 C 5.96875 -0.375 5.40625 -0.34375 5.1875 -0.34375 C 5.03125 -0.34375 4.921875 -0.34375 4.921875 -0.125 C 4.921875 0 5.046875 0 5.078125 0 C 5.515625 0 5.984375 -0.03125 6.4375 -0.03125 C 6.703125 -0.03125 7.390625 0 7.671875 0 C 7.734375 0 7.859375 0 7.859375 -0.21875 C 7.859375 -0.34375 7.75 -0.34375 7.609375 -0.34375 C 6.9375 -0.34375 6.9375 -0.421875 6.90625 -0.734375 L 6.234375 -7.546875 C 6.21875 -7.765625 6.21875 -7.8125 6.03125 -7.8125 C 5.859375 -7.8125 5.8125 -7.734375 5.75 -7.625 Z M 3.265625 -2.859375 L 5.40625 -6.453125 L 5.765625 -2.859375 Z M 3.265625 -2.859375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.78125 -7.765625 C 4.84375 -7.90625 4.84375 -7.953125 4.84375 -7.96875 C 4.84375 -8.078125 4.75 -8.171875 4.625 -8.171875 C 4.546875 -8.171875 4.46875 -8.140625 4.4375 -8.078125 L 0.65625 2.3125 C 0.59375 2.453125 0.59375 2.5 0.59375 2.515625 C 0.59375 2.625 0.703125 2.71875 0.8125 2.71875 C 0.953125 2.71875 1 2.65625 1.0625 2.46875 Z M 4.78125 -7.765625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4 -4.359375 L 4.9375 -4.359375 C 5.15625 -4.359375 5.265625 -4.359375 5.265625 -4.578125 C 5.265625 -4.703125 5.15625 -4.703125 4.96875 -4.703125 L 4.0625 -4.703125 L 4.296875 -5.9375 C 4.34375 -6.171875 4.5 -6.953125 4.5625 -7.078125 C 4.65625 -7.28125 4.84375 -7.453125 5.078125 -7.453125 C 5.109375 -7.453125 5.40625 -7.453125 5.609375 -7.25 C 5.125 -7.203125 5.015625 -6.828125 5.015625 -6.65625 C 5.015625 -6.40625 5.21875 -6.28125 5.421875 -6.28125 C 5.703125 -6.28125 6.015625 -6.515625 6.015625 -6.9375 C 6.015625 -7.4375 5.515625 -7.6875 5.078125 -7.6875 C 4.703125 -7.6875 4.015625 -7.5 3.6875 -6.40625 C 3.625 -6.1875 3.59375 -6.078125 3.328125 -4.703125 L 2.578125 -4.703125 C 2.359375 -4.703125 2.25 -4.703125 2.25 -4.5 C 2.25 -4.359375 2.34375 -4.359375 2.546875 -4.359375 L 3.265625 -4.359375 L 2.453125 -0.046875 C 2.25 1 2.078125 2 1.5 2 C 1.46875 2 1.1875 2 0.984375 1.796875 C 1.484375 1.765625 1.578125 1.375 1.578125 1.203125 C 1.578125 0.953125 1.390625 0.828125 1.171875 0.828125 C 0.890625 0.828125 0.578125 1.0625 0.578125 1.484375 C 0.578125 1.96875 1.0625 2.234375 1.5 2.234375 C 2.109375 2.234375 2.546875 1.59375 2.734375 1.171875 C 3.09375 0.484375 3.34375 -0.828125 3.34375 -0.90625 Z M 4 -4.359375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.75 -0.84375 C 1.640625 -0.421875 1.609375 -0.34375 0.75 -0.34375 C 0.5625 -0.34375 0.453125 -0.34375 0.453125 -0.125 C 0.453125 0 0.5625 0 0.75 0 L 4.640625 0 C 6.375 0 7.65625 -1.28125 7.65625 -2.359375 C 7.65625 -3.140625 7.03125 -3.78125 5.96875 -3.890625 C 7.09375 -4.09375 8.25 -4.90625 8.25 -5.9375 C 8.25 -6.75 7.53125 -7.453125 6.21875 -7.453125 L 2.546875 -7.453125 C 2.34375 -7.453125 2.234375 -7.453125 2.234375 -7.234375 C 2.234375 -7.109375 2.328125 -7.109375 2.546875 -7.109375 C 2.5625 -7.109375 2.765625 -7.109375 2.953125 -7.09375 C 3.15625 -7.0625 3.25 -7.0625 3.25 -6.921875 C 3.25 -6.875 3.234375 -6.84375 3.203125 -6.703125 Z M 3.390625 -3.984375 L 4.0625 -6.703125 C 4.171875 -7.078125 4.1875 -7.109375 4.65625 -7.109375 L 6.0625 -7.109375 C 7.03125 -7.109375 7.25 -6.46875 7.25 -5.984375 C 7.25 -5.03125 6.3125 -3.984375 4.984375 -3.984375 Z M 2.90625 -0.34375 C 2.75 -0.34375 2.71875 -0.34375 2.65625 -0.34375 C 2.546875 -0.359375 2.515625 -0.375 2.515625 -0.453125 C 2.515625 -0.484375 2.515625 -0.515625 2.578125 -0.703125 L 3.328125 -3.75 L 5.390625 -3.75 C 6.4375 -3.75 6.640625 -2.9375 6.640625 -2.46875 C 6.640625 -1.390625 5.671875 -0.34375 4.390625 -0.34375 Z M 2.90625 -0.34375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.09375 -0.578125 C 2.09375 -0.890625 1.828125 -1.15625 1.515625 -1.15625 C 1.203125 -1.15625 0.9375 -0.890625 0.9375 -0.578125 C 0.9375 -0.265625 1.203125 0 1.515625 0 C 1.828125 0 2.09375 -0.265625 2.09375 -0.578125 Z M 2.09375 -0.578125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.890625 -4.0625 L 4.125 -4.0625 C 3.765625 -2.453125 3.671875 -1.984375 3.671875 -1.25 C 3.671875 -1.09375 3.671875 -0.796875 3.75 -0.421875 C 3.859375 0.046875 3.984375 0.125 4.140625 0.125 C 4.359375 0.125 4.59375 -0.078125 4.59375 -0.296875 C 4.59375 -0.359375 4.59375 -0.375 4.53125 -0.53125 C 4.203125 -1.3125 4.203125 -2.03125 4.203125 -2.328125 C 4.203125 -2.90625 4.28125 -3.5 4.40625 -4.0625 L 5.65625 -4.0625 C 5.796875 -4.0625 6.1875 -4.0625 6.1875 -4.4375 C 6.1875 -4.703125 5.953125 -4.703125 5.75 -4.703125 L 2.09375 -4.703125 C 1.859375 -4.703125 1.4375 -4.703125 0.953125 -4.1875 C 0.578125 -3.765625 0.296875 -3.265625 0.296875 -3.203125 C 0.296875 -3.203125 0.296875 -3.09375 0.421875 -3.09375 C 0.515625 -3.09375 0.53125 -3.140625 0.59375 -3.234375 C 1.140625 -4.0625 1.765625 -4.0625 1.984375 -4.0625 L 2.609375 -4.0625 C 2.25 -2.75 1.671875 -1.421875 1.203125 -0.4375 C 1.125 -0.265625 1.125 -0.25 1.125 -0.171875 C 1.125 0.03125 1.296875 0.125 1.4375 0.125 C 1.765625 0.125 1.859375 -0.1875 1.984375 -0.59375 C 2.140625 -1.09375 2.140625 -1.109375 2.28125 -1.65625 Z M 2.890625 -4.0625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.265625 -2.71875 C 2.40625 -3.03125 2.40625 -3.046875 2.515625 -3.34375 C 2.59375 -3.5625 2.65625 -3.71875 2.65625 -3.921875 C 2.65625 -4.421875 2.296875 -4.828125 1.75 -4.828125 C 0.734375 -4.828125 0.3125 -3.234375 0.3125 -3.140625 C 0.3125 -3.03125 0.421875 -3.03125 0.453125 -3.03125 C 0.5625 -3.03125 0.5625 -3.046875 0.625 -3.234375 C 0.921875 -4.25 1.359375 -4.578125 1.71875 -4.578125 C 1.8125 -4.578125 2 -4.578125 2 -4.234375 C 2 -4 1.921875 -3.78125 1.875 -3.671875 C 1.78125 -3.375 1.296875 -2.109375 1.125 -1.640625 C 1.015625 -1.359375 0.875 -1 0.875 -0.78125 C 0.875 -0.265625 1.25 0.125 1.765625 0.125 C 2.796875 0.125 3.203125 -1.46875 3.203125 -1.5625 C 3.203125 -1.671875 3.09375 -1.671875 3.0625 -1.671875 C 2.953125 -1.671875 2.953125 -1.640625 2.90625 -1.46875 C 2.703125 -0.78125 2.34375 -0.125 1.78125 -0.125 C 1.609375 -0.125 1.53125 -0.234375 1.53125 -0.484375 C 1.53125 -0.75 1.59375 -0.90625 1.84375 -1.578125 Z M 2.265625 -2.71875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 7.875 -3.640625 C 7.875 -3.875 7.8125 -3.984375 7.71875 -3.984375 C 7.671875 -3.984375 7.578125 -3.921875 7.5625 -3.703125 C 7.53125 -2.65625 6.8125 -2.0625 6.046875 -2.0625 C 5.359375 -2.0625 4.828125 -2.53125 4.296875 -3 C 3.734375 -3.5 3.171875 -4 2.4375 -4 C 1.25 -4 0.59375 -2.796875 0.59375 -1.8125 C 0.59375 -1.46875 0.734375 -1.46875 0.75 -1.46875 C 0.875 -1.46875 0.90625 -1.671875 0.90625 -1.71875 C 0.953125 -2.90625 1.765625 -3.390625 2.4375 -3.390625 C 3.125 -3.390625 3.640625 -2.921875 4.171875 -2.453125 C 4.734375 -1.953125 5.296875 -1.453125 6.046875 -1.453125 C 7.234375 -1.453125 7.875 -2.65625 7.875 -3.640625 Z M 7.875 -3.640625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.9375 -4.828125 L 0.40625 -4.703125 L 0.40625 -4.359375 C 1.109375 -4.359375 1.203125 -4.296875 1.203125 -3.765625 L 1.203125 -0.828125 C 1.203125 -0.34375 1.09375 -0.34375 0.359375 -0.34375 L 0.359375 0 C 0.703125 -0.015625 1.296875 -0.03125 1.5625 -0.03125 C 1.9375 -0.03125 2.328125 -0.015625 2.6875 0 L 2.6875 -0.34375 C 1.96875 -0.34375 1.9375 -0.390625 1.9375 -0.8125 Z M 1.96875 -6.71875 C 1.96875 -7.0625 1.703125 -7.296875 1.390625 -7.296875 C 1.0625 -7.296875 0.8125 -7 0.8125 -6.71875 C 0.8125 -6.421875 1.0625 -6.140625 1.390625 -6.140625 C 1.703125 -6.140625 1.96875 -6.375 1.96875 -6.71875 Z M 1.96875 -6.71875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.203125 -3.75 L 1.203125 -0.828125 C 1.203125 -0.34375 1.078125 -0.34375 0.34375 -0.34375 L 0.34375 0 C 0.734375 -0.015625 1.28125 -0.03125 1.578125 -0.03125 C 1.859375 -0.03125 2.4375 -0.015625 2.796875 0 L 2.796875 -0.34375 C 2.078125 -0.34375 1.953125 -0.34375 1.953125 -0.828125 L 1.953125 -2.828125 C 1.953125 -3.96875 2.71875 -4.578125 3.421875 -4.578125 C 4.109375 -4.578125 4.234375 -3.984375 4.234375 -3.375 L 4.234375 -0.828125 C 4.234375 -0.34375 4.109375 -0.34375 3.375 -0.34375 L 3.375 0 C 3.765625 -0.015625 4.3125 -0.03125 4.609375 -0.03125 C 4.890625 -0.03125 5.46875 -0.015625 5.828125 0 L 5.828125 -0.34375 C 5.109375 -0.34375 4.984375 -0.34375 4.984375 -0.828125 L 4.984375 -2.828125 C 4.984375 -3.96875 5.765625 -4.578125 6.453125 -4.578125 C 7.140625 -4.578125 7.265625 -3.984375 7.265625 -3.375 L 7.265625 -0.828125 C 7.265625 -0.34375 7.140625 -0.34375 6.40625 -0.34375 L 6.40625 0 C 6.796875 -0.015625 7.34375 -0.03125 7.640625 -0.03125 C 7.921875 -0.03125 8.5 -0.015625 8.859375 0 L 8.859375 -0.34375 C 8.296875 -0.34375 8.03125 -0.34375 8.015625 -0.671875 L 8.015625 -2.75 C 8.015625 -3.6875 8.015625 -4.03125 7.671875 -4.421875 C 7.53125 -4.609375 7.171875 -4.828125 6.53125 -4.828125 C 5.609375 -4.828125 5.140625 -4.171875 4.953125 -3.75 C 4.796875 -4.703125 3.984375 -4.828125 3.5 -4.828125 C 2.703125 -4.828125 2.1875 -4.359375 1.890625 -3.671875 L 1.890625 -4.828125 L 0.34375 -4.703125 L 0.34375 -4.359375 C 1.109375 -4.359375 1.203125 -4.28125 1.203125 -3.75 Z M 1.203125 -3.75 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.53125 -7.125 L 4.359375 -7.28125 C 4.359375 -7.28125 3.953125 -6.765625 3.46875 -6.765625 C 3.21875 -6.765625 2.9375 -6.921875 2.765625 -7.03125 C 2.46875 -7.203125 2.265625 -7.28125 2.078125 -7.28125 C 1.671875 -7.28125 1.46875 -7.046875 0.90625 -6.4375 L 1.078125 -6.265625 C 1.078125 -6.28125 1.5 -6.796875 1.96875 -6.796875 C 2.21875 -6.796875 2.5 -6.625 2.6875 -6.515625 C 2.984375 -6.34375 3.171875 -6.265625 3.359375 -6.265625 C 3.78125 -6.265625 3.984375 -6.515625 4.53125 -7.125 Z M 4.53125 -7.125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 6.109375 -2.71875 C 6.109375 -2.96875 6.015625 -3 5.96875 -3 C 5.859375 -3 5.84375 -2.8125 5.84375 -2.6875 C 5.8125 -2.109375 5.390625 -1.484375 4.6875 -1.484375 C 4.21875 -1.484375 3.828125 -1.765625 3.359375 -2.203125 C 2.859375 -2.671875 2.4375 -3.015625 1.875 -3.015625 C 0.96875 -3.015625 0.46875 -2.0625 0.46875 -1.28125 C 0.46875 -1 0.5625 -0.984375 0.59375 -0.984375 C 0.65625 -0.984375 0.71875 -1.03125 0.71875 -1.234375 C 0.75 -2.015625 1.296875 -2.5 1.875 -2.5 C 2.359375 -2.5 2.734375 -2.21875 3.21875 -1.78125 C 3.71875 -1.3125 4.140625 -0.96875 4.6875 -0.96875 C 5.59375 -0.96875 6.109375 -1.90625 6.109375 -2.71875 Z M 6.109375 -2.71875 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 0.007,
    y: 47.043
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 53.642,
    y: 47.043
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 61.823825,
    y: 47.043
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-1",
    x: 66.673,
    y: 47.043
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-1",
    x: 120.611,
    y: 47.043
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-2",
    x: 123.641548,
    y: 47.043
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 134.551,
    y: 47.043
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 186.52,
    y: 47.043
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 195.340007,
    y: 47.043
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M -87.165562 0.00153125 L -51.3765 0.00153125 ",
    transform: "matrix(1,0,0,-1,99.189,44.107)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 49.804688 44.105469 L 46.617188 42.511719 L 47.8125 44.105469 L 46.617188 45.699219 "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 24.264,
    y: 52.639
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-1",
    x: 30.482,
    y: 54.275
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M -87.165562 4.571844 C -29.517125 38.337469 25.428188 38.677312 81.764125 6.618719 ",
    transform: "matrix(1,0,0,-1,99.189,44.107)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 182.683594 38.476562 L 180.703125 35.511719 L 180.953125 37.488281 L 179.125 38.285156 "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 93.941,
    y: 7.995
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M -20.196812 0.00153125 L 15.596156 0.00153125 ",
    transform: "matrix(1,0,0,-1,99.189,44.107)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 116.777344 44.105469 L 113.589844 42.511719 L 114.785156 44.105469 L 113.589844 45.699219 "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-3",
    x: 96.975,
    y: 55.228
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 94.627,
    y: 58.107
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 45.713344 0.00153125 L 81.502406 0.00153125 ",
    transform: "matrix(1,0,0,-1,99.189,44.107)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 182.683594 44.105469 L 179.496094 42.511719 L 180.691406 44.105469 L 179.496094 45.699219 "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 162.034,
    y: 52.639
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg4);
export default __webpack_public_path__ + "static/media/svg4.0e4d54c29e2712dfba942dd201bf3b52.svg";
export { ForwardRef as ReactComponent };